<template>
  <div id="app">
    <TheSplash />
    <div id="js-scroll">
      <transition name="fade">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import debounce from '@/modules/debounce'
import TheSplash from '@/components/TheSplash.vue'
export default {
  name: 'App',

  metaInfo: {
    title: 'OCEANTRICO JET',
    titleTemplate: '%s | OCEANTRICO JET'
  },

  components: { TheSplash },

  computed: {
    ...mapState(['isMobile'])
  },

  mounted() {
    this.$nextTick(() => {
      this.setFillHeight()
      window.scrollTo(0, 0)

      if (!this.isMobile) {
        window.addEventListener(
          'resize',
          debounce(() => {
            this.setFillHeight()
            this.resize()
          }, 20)
        )
      }
    })
  },

  methods: {
    ...mapActions(['resize', 'setScrollY']),

    setFillHeight() {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
  }
}
</script>

<style lang="scss">
@import '~@/scss/site-setting.scss';
@import '@/scss/base.scss';
@import '@/scss/locomotive.scss';

/* layout */
@import '@/scss/layout/l-container.scss';
@import '@/scss/layout/l-wrapper.scss';

/* common */
@import '~@/scss/common/c-section-title.scss';

:root {
  --breakpoint-mobile: 750px;
  --main-color: #e40718;
}

#app {
  font-family: $font-ja;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: var(--main-color);

  @media screen and (max-width: $breakpoint-mobile) {
    overflow: hidden;
  }
}

.image-fadeIn {
  img {
    opacity: 0;
    transition: opacity 0.65s;
  }

  &.lazyloaded {
    img.lazyloaded {
      opacity: 1;
    }
  }
}
</style>
